// frontend/packs/ads.js

import 'components/global/ads/misc-ads.css';

import AdsController from 'controllers/ads-controller';
import StickyAdContainerController from 'components/util/ad-container/sticky-ad-container-controller';

window.EezyStimulusApplication.register('ads-main', AdsController);
window.EezyStimulusApplication.register('sticky-ad-container', StickyAdContainerController);
